﻿export type ResultatValg = ResultatValgVisning;

export interface ResultatValgVisning {
    visBoksB: boolean;
    visBoksC: boolean;
    visBoksD: boolean;
    visResultatA: boolean;
    visResultatB: boolean;
    visGenerellFeil: boolean;
    visEkstraboks: boolean;
}

export const SET_VISNING = 'SET_VISNING';

export interface SetVisningAction {
    type: typeof SET_VISNING;
    payload: Partial<ResultatValgVisning>;
}

export type ResultatActionTypes = SetVisningAction;
